import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APIResponse } from '../../../utils/models/response';
import { Login } from '../../models/login';
import { LoginService } from '../../services/login.service'; 
import { CoreSaveService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'


@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  entity: Login;
  forgotPassword: boolean = false;
  CreateAccount: boolean = false;
  ActiveUser: string = "";
  defaultRowsCount: number;

  constructor(
    private loginService: LoginService, 
    private router: Router,
    private route: ActivatedRoute,
    private configService: ConfigService,

  ) {
    this.entity = new Login();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));

  }

  ngOnInit(): void {
    if (Number(this.route.snapshot.paramMap.get('val')) === 1) {
      this.ActiveUser = "CN";
    }
  }

  login(): void {
    if (this.validateLogin()) {
      this.loginService.validateSignIn(this.entity).subscribe((response: APIResponse) => {
        if (response.Success) {
          localStorage.removeItem('currentUser');
          localStorage.setItem('currentUser', JSON.stringify(response.Data));
          this.router.navigate(['landingpage/landing-menu']);
        } else {
          alert('Invalid username or password');
        }
      });
    } else {
      alert('Please enter all mandatory details');
    }
  }

  validateLogin(): boolean {
    let valid = true;
    console.log(this.entity)
    if (!this.entity.Username) {
      valid = false;
    }
    else if (!this.entity.Password) {
      valid = false;
    }
    return valid;
  }

  Click(): void {
    {
      this.CreateAccount = true;
    }
  }
  linkClick(): void {
    {
      this.forgotPassword = true;

    }
  }
  closeForgotPassword() {
    this.forgotPassword = false;
  }
  close() {
    this.CreateAccount = false;
  }
  closeAddUser(): void {
    this.CreateAccount = false;
  }


}

